import React from "react";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import ListItemText from "@mui/material/ListItemText";
import { timeSlotDropdownListProps as Props } from "../../types";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const timslots = [
  "7.00 am - 7.30 am",
  "7.30 am - 8.00 am",
  "8.00 am - 8.30 am",
  "8.30 am - 9.00 am",
  "9.00 am - 9.30 am",
  "9.30 am - 10.00 am",
  "10.00 am - 10.30 am",
  "10.30 am - 11.00 am",
  "11.00 am - 11.30 am",
  "11.30 am - 12.00 pm",
  "12.00 pm - 12.30 pm",
  "12.30 pm - 1.00 pm",
  "1.00 pm - 1.30 pm",
  "1.30 pm - 2.00 pm",
  "2.00 pm - 2.30 pm",
  "2.30 pm - 3.00 pm",
  "3.00 pm - 3.30 pm",
  "3.30 pm - 4.00 pm",
  "4.00 pm - 4.30 pm",
  "4.30 pm - 5.00 pm",
  "5.00 pm - 5.30 pm",
  "5.30 pm - 6.00 pm",
  "6.00 pm - 6.30 pm",
  "6.30 pm - 7.00 pm",
  "7.00 pm - 7.30 pm",
  "7.30 pm - 8.00 pm",
  "8.00 pm - 8.30 pm",
  "8.30 pm - 9.00 pm",
  "9.00 pm - 9.30 pm",
  "9.30 pm - 10.00 pm",
  "10.00 pm - 10.30 pm",
  "10.30 pm - 11.00 pm",
  "11.00 pm - 11.30 pm",
  "11.30 pm - 12.00 am",
  "12.00 am - 12.30 am",
  "12.30 am - 1.00 am",
  "1.00 am - 1.30 am",
  "1.30 am - 2.00 am",
  "2.00 am - 2.30 am",
  "2.30 am - 3.00 am",
  "3.00 am - 3.30 am",
  "3.30 am - 4.00 am",
  "4.00 am - 4.30 am",
  "4.30 am - 5.00 am",
  "5.00 am - 5.30 am",
  "5.30 am - 6.00 am",
  "6.00 am - 6.30 am",
  "6.30 am - 7.00 am",
];

const TimeSlotDropdownList: React.FC<Props> = ({
  alltimeslots,
  onInputTimeSlotsChange,
  timeslotWeekDay,
  timeslotStatus,
}) => {
  return (
    <React.Fragment>
      <FormControl
        sx={{
          marginBottom: { sm: "10px" },
          marginLeft: 0,
          width: { xs: "200px", sm: "234px", md: "234px" },
          height: { xs: "42px", sm: "46px", md: "50px" },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              border: "1px solid #94949533",
            },
            "&:hover fieldset": {
              border: "1px solid #94949533",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#94949533",
            },
            "&:hover": {
              border: "1px solid #94949533",
            },
            fontFamily: "Avenir",
            fontSize: {
              xs: "14px",
              sm: "16px",
              md: "18px",
              xl: "24px",
            },
            lineHeight: {
              xs: "20px",
              sm: "22px",
              md: "26px",
              xl: "33px",
            },
          },
        }}
      >
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          displayEmpty
          multiple
          value={alltimeslots}
          onChange={onInputTimeSlotsChange}
          input={<OutlinedInput />}
          name={timeslotWeekDay}
          disabled={timeslotStatus ? false : true}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return (
                <Typography
                  variant="h6"
                  gutterBottom
                  component="div"
                  sx={{
                    letterSpacing: 0,
                    color: "#333333",
                    opacity: 0.6,
                    fontFamily: "Avenir",
                    fontSize: {
                      xs: "14px",
                      sm: "16px",
                      md: "18px",
                      xl: "24px",
                    },
                    lineHeight: {
                      xs: "20px",
                      sm: "22px",
                      md: "26px",
                      xl: "33px",
                    },
                    mb: 0,
                  }}
                >
                  Time Slot
                </Typography>
              );
            }
            return selected.join(", ");
          }}
          MenuProps={MenuProps}
          sx={{
            border: "1px solid #94949533",
            borderRadius: "4px",
            width: { xs: "200px", sm: "234px", md: "230px", xl: "234px" },
            height: { xs: "40px", sm: "42px", md: "44px", xl: "50px" },
          }}
        >
          {timslots.map((name, index) => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={alltimeslots.indexOf(name) > -1} />
              <ListItemText
                primary={name}
                sx={{
                  "& .MuiTypography-root": {
                    fontFamily: "Avenir",
                    fontSize: {
                      xs: "14px",
                      sm: "15px",
                      md: "18px",
                      xl: "24px",
                    },
                    lineHeight: {
                      xs: "20px",
                      sm: "22px",
                      md: "26px",
                      xl: "33px",
                    },
                    letterSpacing: 0,
                    color: "#333333",
                    opacity: 1,
                    mb: 0,
                  },
                }}
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </React.Fragment>
  );
};

export default TimeSlotDropdownList;
